import { useState } from 'react'

import { Space } from 'app/common/templates-next/report-template'

import { Filters } from './filters'
import { Result } from './result/Result'

const OrdersByClasses = () => {
  const [reportID, setReportID] = useState<null | string>(null)
  return (
    <>
      <Filters onReportId={setReportID} />
      <Space />
      <Result reportID={reportID} onReportId={setReportID} />
    </>
  )
}

export default OrdersByClasses
